module.exports = __webpack_public_path__ + "img/canbadge_daishi_70_90mm.579f2973.png";